'use strict';

const _ = require('underscore');
const CommentReaction = require('communication/domain/comment-reaction/reaction');
const CommentReactionActionFactory = require('communication/domain/comment-reaction/action-factory');

class Factory {
    constructor(project) {
        this._project = project;
    }

    build(json) {
        return new Promise(resolve => {
            const actionsJSON = json.actions || [];
            Promise.all(
                _.map(actionsJSON, actionJSON => {
                    actionJSON._project = this._project;
                    return new CommentReactionActionFactory(this._project).build(actionJSON);
                })
            ).then(actions => {
                json.actions = actions;
                resolve(new CommentReaction(json));
            });
        });
    }
}

module.exports = Factory;



// WEBPACK FOOTER //
// ./communication/domain/comment-reaction/reaction-factory.js